import React, { useState, useEffect, useRef } from "react";
import "./NewsDetails.css";
import Nav from "../Nav/Nav";
import { useLocation, useNavigate } from "react-router-dom";
import Footer from "../Footer/Footer";
import ApiService from "../Service/ApiService";
import { useParams } from "react-router-dom";
import DescriptionNews from "../DescriptionNews/DescriptionNews";
import NewsImageGallery from "../NewsImageGallery/NewsImageGallery";
import TransitionNews from "../TransitionNews/TransitionNews";
import newsData from "../../data/news.json";

const NewsDetails = () => {
  const { newsId } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const { targetId } = state || {};
  const [allNews, setAllNews] = useState([]);

  const [news, setNews] = useState([]);
  useEffect(() => {
    if (!newsId || newsData.length === 0) return;

    const foundNews = newsData.find(
      (n) => String(n.news_id) === String(newsId)
    );

    if (foundNews) {
      setNews(foundNews);
    } else {
      console.error(`News with ID ${newsId} not found`);
    }
  }, [newsId]);

  useEffect(() => {
    setAllNews(newsData);
  }, []);

  useEffect(() => {
    if (!isLoading && targetId) {
      const timeout = setTimeout(() => {
        const el = document.getElementById(targetId);
        if (el) {
          el.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 1500);

      return () => clearTimeout(timeout);
    }
  }, [isLoading, targetId]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2650);

    return () => clearTimeout(timer);
  }, []);

  const [isAlbanian, setIsAlbanian] = useState(() => {
    const savedLanguage = localStorage.getItem("language");
    return savedLanguage !== null ? JSON.parse(savedLanguage) : true;
  });

  const toggleLanguage = () => {
    setIsAlbanian((prev) => {
      const newLanguage = !prev;
      localStorage.setItem("language", JSON.stringify(newLanguage));
      return newLanguage;
    });
  };

  const getNextNewsId = () => {
    if (!news || !allNews.length) return null;
    const currentIndex = allNews.findIndex(
      (n) => String(n.news_id) === String(news.news_id)
    );
    const nextIndex = (currentIndex + 1) % allNews.length;
    return allNews[nextIndex]?.news_id;
  };

  const getPrevNewsId = () => {
    if (!news || !allNews.length) return null;
    const currentIndex = allNews.findIndex(
      (n) => String(n.news_id) === String(news.news_id)
    );
    const prevIndex = (currentIndex - 1 + allNews.length) % allNews.length;
    return allNews[prevIndex]?.news_id;
  };

  const handleNavigate = (newsId) => {
    navigate(`/newsdetails/${newsId}`);
  };

  return (
    <>
      <div className="newsdetails-container-up">
        <Nav isAlbanian={isAlbanian} toggleLanguage={toggleLanguage} />
        <div className="newsdetails-container">
          {getPrevNewsId() && (
            <button
              className="newsdetails-prevTop-button-outside"
              onClick={() => handleNavigate(getPrevNewsId())}
            >
              <img
                src="/prevup.png"
                alt="Next"
                className="newsdetails-prevTop-btn-img"
              />
            </button>
          )}
          {getNextNewsId() && (
            <button
              className="newsdetails-next-button-outside"
              onClick={() => handleNavigate(getNextNewsId())}
            >
              <img
                src="/nextup.png"
                alt="Next"
                className="newsdetails-nextPro-btn-img"
              />
            </button>
          )}
          <img
            src={news.news_image_url}
            alt="newsdetails-photo"
            className="newsdetails-image"
          />
          <div className="overlay">
            <div className="vertical-line left"></div>
            <div className="vertical-line right"></div>
            <div className="hero-title">
              <h1 className="overlay-text">
                <strong>
                  <span class="protest-font"></span>
                  <img
                    src="/underlined2-1.png"
                    alt="Underline decoration"
                    className="underline-image"
                  />
                </strong>{" "}
              </h1>
            </div>
            <div className="bottom-line"></div>
          </div>
        </div>
        <DescriptionNews isAlbanian={isAlbanian} newsId={newsId} />
        <NewsImageGallery isAlbanian={isAlbanian} newsId={newsId} />
        <TransitionNews isAlbanian={isAlbanian} />
      </div>
      <Footer isAlbanian={isAlbanian} />
    </>
  );
};

export default NewsDetails;
